import * as ko from 'knockout'
import ObservableResultsPage from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/Betting-v2/Model/Observables/ObservableResultsPage'
import { ResultsFieldViewModel } from './ResultsFieldViewModel'
import { ResultsViewModel } from './ResultsViewModel'
import fieldViewTemplate from './results.field.view.tpl.html'
import resultsViewTemplate from './results.view.tpl.html'

if (!ko.components.isRegistered('results-view')) {
  ko.components.register('results-view', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsViewModel(params)
        return viewModel
      },
    },
    template: resultsViewTemplate,
  })
}
if (!ko.components.isRegistered('results-field-view')) {
  ko.components.register('results-field-view', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsFieldViewModel(params)
        return viewModel
      },
    },
    template: fieldViewTemplate,
  })
}
